import React, { useState } from "react";
import classes from "./styles.module.scss";
import { Button } from "Components/ReactstrapSlim";
import { Close } from "Components/Icons";
import moment from "moment";

function getScenarioDescription(scenarioId?: Guid | null) {
   if (scenarioId == LiquidSpaceConfig.Const.WorkspaceScenario.Coworking) {
      return "Coworking Pass";
   }

   return Object.getOwnPropertyNames(LiquidSpaceConfig.Const.WorkspaceScenario)
      .find(x => LiquidSpaceConfig.Const.WorkspaceScenario[x] == scenarioId)
      ?? "space";
}

interface BannerProps {
   shareReservation: LSCommon.Service.LSWebUI.Models.XPP.SharedReservationViewModel;
   onBook: (date?: Date) => void;
}

const Banner: React.FC<BannerProps> = ({ shareReservation, onBook }) => {
   const [isVisible, setVisible] = useState(true);

   return isVisible
      ? <div className={classes.container}>
         <div className={classes.l}>
            {
               shareReservation.PictureUrl
                  ? <img className={classes.img} alt={shareReservation.FirstName ?? ""} src={shareReservation.PictureUrl} />
                  : null
            }
            <div className={classes.lr}>
               <span className={classes.lr1}>
                  {shareReservation.FirstName ?? shareReservation.Email ?? "Member"}
                  {" has a reservation here at "}
                  <span className="h6">{shareReservation.WorkspaceName}</span>
               </span>
               <span className={classes.lr2}>
                  {`Join ${shareReservation.FirstName ?? shareReservation.Email ?? "member"} and work together on `}
                  {moment(shareReservation.ReservationStartTime).format("dddd, MMMM D")}
                  {" from "}
                  {moment(shareReservation.ReservationStartTime).format("hh:mm A")}
                  {" - "}
                  {moment(shareReservation.ReservationEndTime).format("hh:mm A")}
               </span>
            </div>
         </div>
         <div className={classes.buttons}>
            <Button color="link" className={classes.cta} onClick={() => onBook(moment(shareReservation.ReservationStartTime).startOf("day").toDate())}>
               {"Work with "}
               {shareReservation.FirstName ?? shareReservation.Email ?? "member"}
            </Button>
            <Button color="icon" className={classes.close} onClick={() => setVisible(false)}><Close /></Button>
         </div>
      </div>
      : null
}

export default Banner;